/** A contract address in the shape the cart customer input expects */
const toCartAddress = ({ type, firstName, lastName, street, postalCode, city, country, email, phone, }) => ({
    type,
    firstName: firstName ?? "",
    lastName: lastName ?? "",
    street: street ?? "",
    postalCode: postalCode ?? "",
    city: city ?? "",
    country: country ?? "",
    phone: phone ?? undefined,
    email: email ?? undefined,
    meta: [],
});
/**
 * The addresses of a holdback gift order. Backoffice can change the addresses
 * of the contract independently of the customer profile, so the contract's
 * addresses win: a contract address replaces the profile addresses of the same
 * type. Profile addresses of types the contract has no address for are kept,
 * and without contract addresses the profile addresses are used as they are.
 */
export const resolveHoldbackAddresses = (profileAddresses, contractAddresses) => {
    if (!contractAddresses?.length)
        return [...profileAddresses];
    const contractTypes = new Set(contractAddresses.map(({ type }) => type));
    return [
        ...profileAddresses.filter(({ type }) => !contractTypes.has(type)),
        ...contractAddresses.map(toCartAddress),
    ];
};
